import { useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";

import "./index.scss";

const IS_LOCALHOST = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

const Captcha = ({ onChange }) => {
  useEffect(() => {
    if (IS_LOCALHOST) onChange("localhost-bypass");
  }, [onChange]);

  if (IS_LOCALHOST) return null;

  return (
    <div className="ucr-captcha">
      <ReCAPTCHA
        size="normal"
        onChange={onChange}
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      />
    </div>
  );
};

export default Captcha;
